import { devToolsButtonVariants } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsButton/index.styles';
import type { DevToolsButtonProps } from 'Modules/softphone/components/SoftphoneDevTools/DevToolsButton/index.types';
import React from 'react';
import { cn } from '~/lib/utils';

/**
 * DevToolsButton - The panel's button, in three jobs
 *
 * `default` acts, `destructive` throws something away, `export` produces a
 * file and hovers to the accent.
 */
export const DevToolsButton: React.FC<DevToolsButtonProps> = ({
  variant,
  className,
  children,
  ...props
}) => (
  <button
    type="button"
    className={cn(
      devToolsButtonVariants({ variant }),
      'disabled:pointer-events-none disabled:opacity-50',
      className
    )}
    {...props}
  >
    {children}
  </button>
);
